import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { defaultFaqItems, defaultTransport } from '../data/faqSeed';

/**
 * Returns the FAQ config from Firestore. If the document doesn't exist or has no items,
 * seeds it with default content first, then returns the data.
 */
export async function getFaqConfig() {
  const ref = doc(db, 'settings', 'faq');
  const snap = await getDoc(ref);
  const data = snap.exists() ? snap.data() : null;
  const items = data?.items;
  const hasValidItems = Array.isArray(items) && items.length > 0;
  if (!hasValidItems) {
    await seedFaqConfig();
    const again = await getDoc(ref);
    return again.exists() ? again.data() : { items: defaultFaqItems, transport: defaultTransport };
  }
  return {
    items: data.items,
    transport: data.transport || defaultTransport
  };
}

/**
 * Writes default FAQ items and transport to Firestore. Safe to call multiple times;
 * only use when you want to reset or initialise (e.g. first run).
 */
export async function seedFaqConfig() {
  const ref = doc(db, 'settings', 'faq');
  await setDoc(ref, {
    items: defaultFaqItems,
    transport: defaultTransport
  });
}

/**
 * Saves FAQ config (items + transport) to Firestore.
 */
export async function saveFaqConfig({ items, transport }) {
  const ref = doc(db, 'settings', 'faq');
  await setDoc(ref, { items, transport });
}
